<template>
    <!--
        作者：kmdshop
        时间：2019-10-25
        描述：订单列表
    -->
    <div class="user">
      <!--搜索表单-->
      <div class="common-seach-wrap">
        <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="店员姓名"><el-input size="small" v-model="searchForm.search_name" placeholder="请输入店员姓名"></el-input></el-form-item>
          <el-form-item label="所属门店"><el-input size="small" v-model="searchForm.store_name" placeholder="请输入门店名称"></el-input></el-form-item>          <el-form-item label="月份">
            <div class="block">
              <span class="demonstration"></span>
              <el-date-picker
                size="small"
                v-model="searchForm.create_time"
                type="month"
              ></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item><el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit" >查询</el-button></el-form-item>
          <el-form-item><el-button size="small" type="primary" icon="el-icon" @click="onRestes" >重置</el-button></el-form-item>
          <el-form-item><el-button size="small" type="primary" icon="el-icon" @click="onExport" >导出</el-button></el-form-item>
        </el-form>
      </div>
      <!--内容-->
      <div class="product-content">
        <div class="table-wrap">
        <el-table size="small" :data="tableData.data" border style="width: 100%" v-loading="loading">
            <el-table-column prop="reserve_record_id" label="序号" ></el-table-column>
            <el-table-column prop="verify.real_name" label="店员姓名" ></el-table-column>
            <el-table-column prop="verify.mobile" label="店员手机号"  ></el-table-column>
            <el-table-column prop="store.store_name" label="所属门店"  ></el-table-column>
            <el-table-column prop="last_performance" label="上月业绩" ></el-table-column>
            <el-table-column prop="current_performance" label="本月业绩"  ></el-table-column>
            <el-table-column prop="total_performance" label="总业绩" ></el-table-column>
            <el-table-column prop="current_times" label="本月服务次数"  ></el-table-column>
            <el-table-column prop="service_times" label="总服务次数" ></el-table-column>
           
          </el-table>
        </div>
  
        <!--分页-->
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="curPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="totalDataNumber"
          ></el-pagination>
        </div>
      </div>
  
    </div>
  </template>
  
  <script>
  import StatisticsApi from '@/api/statistics.js';
  import qs from 'qs'
  export default {
    data() {
      return {
        /*切换菜单*/
        activeName: 'all',
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        searchForm: {
           store_name: '',
            search_name: '',
           create_time: ''
        }
      };
    },
    created() {
      /*获取列表*/
      this.getData();
    },
    methods: {
      /*跨多列*/
      arraySpanMethod(row) {
        if (row.rowIndex % 2 == 0) {
          if (row.columnIndex === 0) {
            return [1, 8];
          }
        }
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.getData();
      },
  
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getData();
      },
  
      /*切换菜单*/
      handleClick(tab, event) {
        let self = this;
        self.curPage = 1;
        self.getData();
      },
  
      /*获取列表*/
      getData() {
        let self = this;
        let Params = this.searchForm;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        StatisticsApi.getClerk(Params, true)
          .then(res => {
            self.loading = false;
            self.tableData.data = res.data.list.data;
            self.totalDataNumber = res.data.list.total;
            
          })
          .catch(error => {});
      },
      onExport: function() {
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/index.php/shop/statistics.clerk/export?' + qs.stringify(this.searchForm);
    },
      onRestes(){
        this.searchForm.store_name = "";
        this.searchForm.search_name = "";
        this.searchForm.create_time = "";
        this.curPage = 1;
        this.tableData = [];
        this.getData();
      },
      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.tableData = [];
        this.getData();
      },
  
      handleCopy(text, event) {
        clip(text, event)
      },
  
    }
  };
  </script>
  <style lang="scss" scoped>
  .product-info {
    padding: 10px 0;
    border-top: 1px solid #eeeeee;
  }
  .order-code .state-text {
    padding: 2px 4px;
    border-radius: 4px;
    background: #808080;
    color: #ffffff;
  }
  .order-code .state-text-red{ background: red;}
  .table-wrap .product-info:first-of-type {
    border-top: none;
  }
  .table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
    background: #f5f7fa;
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/plus/reserve/clerk/index.vue